design-tokens.io
<a href="https://design-tokens.io/privacy-policy" target="_blank"
  >Privacy Policy</a
>
and
<a href="https://design-tokens.io/terms-of-service" target="_blank"
  >Terms of Service</a
>
apply.
